/* KONPEITO — behaviour layer.
   Everything degrades: with JS off, forms post normally and links still work. */
(function () {
  'use strict';

  var cfg = window.KONPEITO || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, scope) { return (scope || document).querySelector(sel); }
  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function lockScroll(on) { document.body.classList.toggle('is-locked', !!on); }

  /* ------------------------------------------------------ sticky header */

  var header = qs('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -------------------------------------------------------- nav drawer */

  var navDrawer = qs('[data-nav-drawer]');

  function openNav() {
    if (!navDrawer) return;
    navDrawer.hidden = false;
    requestAnimationFrame(function () { navDrawer.classList.add('is-open'); });
    lockScroll(true);
    var first = qs('a, button', navDrawer);
    if (first) first.focus();
  }

  function closeNav() {
    if (!navDrawer) return;
    navDrawer.classList.remove('is-open');
    lockScroll(false);
    window.setTimeout(function () { navDrawer.hidden = true; }, 340);
    var toggle = qs('[data-nav-toggle]');
    if (toggle) toggle.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-toggle]')) { openNav(); }
    if (e.target.closest('[data-nav-close]')) { closeNav(); }
  });

  /* ------------------------------------------------------- cart drawer */

  var drawerEnabled = !!qs('[data-cart-drawer]');

  function drawerEl() { return qs('[data-cart-drawer]'); }

  function openCart() {
    var d = drawerEl();
    if (!d) return;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    lockScroll(true);
    var close = qs('[data-cart-close]', d);
    if (close) close.focus();
  }

  function closeCart() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    lockScroll(false);
    window.setTimeout(function () { if (drawerEl()) drawerEl().hidden = true; }, 360);
  }

  function refreshCart(thenOpen) {
    return fetch(window.location.pathname + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-cart-drawer]', parsed);
        var current = drawerEl();
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
        var count = parsed.querySelector('[data-cart-total-count]');
        syncCount(count ? count.getAttribute('data-cart-total-count') : null);
        loadRecommendations();
        if (thenOpen) openCart();
      })
      .catch(function () { window.location.href = cfg.routes.cart; });
  }

  function syncCount(value) {
    if (value === null) return;
    var n = parseInt(value, 10) || 0;
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); }

    var opener = e.target.closest('[data-cart-open]');
    if (opener && drawerEnabled) {
      e.preventDefault();
      openCart();
    }
  });

  /* line item quantity + remove inside the drawer */

  function changeLine(key, quantity, row) {
    if (row) row.classList.add('is-busy');
    return fetch(cfg.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(false); })
      .catch(function () { window.location.href = cfg.routes.cart; });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.getAttribute('data-line-remove'), 0, remove.closest('.line'));
      return;
    }

    var step = e.target.closest('[data-line-step]');
    if (step) {
      e.preventDefault();
      var row = step.closest('.line');
      var input = qs('[data-line-qty]', row);
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-line-step'), 10);
      if (next < 0) next = 0;
      changeLine(input.getAttribute('data-line-key'), next, row);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 0) value = 0;
    changeLine(input.getAttribute('data-line-key'), value, input.closest('.line'));
  });

  /* ------------------------------------------------- add to cart (ajax) */

  function addToCart(body, origin) {
    return fetch(cfg.routes.cart_add, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        if (origin) burst(origin);
        return refreshCart(true);
      });
  }

  /* product form */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.product-form');
    if (!form || !drawerEnabled) return;
    e.preventDefault();

    var btn = qs('[data-add-btn]', form);
    var label = btn ? qs('[data-add-text]', btn) : null;
    var original = label ? label.textContent : '';
    if (btn) { btn.disabled = true; }
    if (label) { label.textContent = 'Adding...'; }

    addToCart(new FormData(form), btn)
      .catch(function (err) {
        var msg = qs('[data-form-error]', form);
        if (msg) {
          msg.textContent = (err && err.description) ? err.description : 'That did not work. Please try again.';
          msg.hidden = false;
        }
      })
      .then(function () {
        if (btn) btn.disabled = false;
        if (label) label.textContent = original;
      });
  });

  /* quick add from a card */
  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick || !drawerEnabled) return;
    e.preventDefault();
    e.stopPropagation();

    quick.classList.add('is-busy');
    var data = new FormData();
    data.append('id', quick.getAttribute('data-quick-add'));
    data.append('quantity', '1');

    addToCart(data, quick)
      .catch(function () { window.location.href = cfg.routes.cart; })
      .then(function () { quick.classList.remove('is-busy'); });
  });

  /* --------------------------------------------------- recommendations */

  function loadRecommendations() {
    var slot = qs('[data-cart-recs]');
    if (!slot) return;
    var productId = slot.getAttribute('data-product-id');
    if (!productId) return;

    var url = cfg.routes.recommendations +
      '?section_id=cart-recommendations&limit=3&intent=complementary&product_id=' + productId;

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var inner = parsed.querySelector('[data-recs-inner]');
        if (inner && inner.children.length) { slot.innerHTML = inner.innerHTML; }
      })
      .catch(function () {});
  }

  loadRecommendations();

  /* ------------------------------------------------------- quantity UI */

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = qs('input', wrap);
    var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = next < 1 ? 1 : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* -------------------------------------------------------- pdp variants */

  qsa('[data-product-root]').forEach(function (root) {
    var dataEl = qs('[data-variant-data]', root);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idField = qs('[data-variant-id]', root);
    var priceSlot = qs('[data-price]', root);
    var addBtn = qs('[data-add-btn]', root);
    var addText = qs('[data-add-text]', root);
    var skuSlot = qs('[data-sku]', root);

    function selected() {
      return qsa('[data-option-input]', root)
        .filter(function (i) { return i.checked; })
        .map(function (i) { return i.value; });
    }

    function findVariant(values) {
      return variants.find(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var thumb = qs('[data-media-id="' + variant.featured_media.id + '"]', root);
      if (thumb) thumb.click();
    }

    function render() {
      var variant = findVariant(selected());

      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }

      if (idField) idField.value = variant.id;

      var store = qs('[data-variant-prices]', root);
      if (store && priceSlot) {
        var markup = store.querySelector('[data-for="' + variant.id + '"]');
        if (markup) priceSlot.innerHTML = markup.innerHTML;
      }

      if (skuSlot) skuSlot.textContent = variant.sku || '';

      if (addBtn) addBtn.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to cart' : 'Sold out';

      updateMedia(variant);

      if (history.replaceState && variant.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    qsa('[data-option-input]', root).forEach(function (input) {
      input.addEventListener('change', render);
    });
  });

  /* ---------------------------------------------------------- gallery */

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-product-root]');
    var stage = qs('#stage-img', root) || qs('.pdp__stage img', root);
    if (!stage) return;

    stage.src = thumb.getAttribute('data-full');
    stage.removeAttribute('srcset');
    qsa('[data-thumb]', root).forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* -------------------------------------------------- collection sort */

  var sortSelect = qs('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------------------------ escape */

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (navDrawer && !navDrawer.hidden) closeNav();
    var d = drawerEl();
    if (d && !d.hidden) closeCart();
  });

  /* ---------------------------------------------------------- sparkles */

  var layer = qs('[data-sparkle-layer]');

  function burst(origin) {
    if (!layer || reduced || cfg.sparkles === false) return;

    var box = origin.getBoundingClientRect();
    var cx = box.left + box.width / 2;
    var cy = box.top + box.height / 2;

    for (var i = 0; i < 9; i++) {
      var s = document.createElement('span');
      s.className = 'sparkle';
      s.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0c.7 4.6 1.9 6.4 4.6 7.2-2.7.8-3.9 2.6-4.6 7.2-.7-4.6-1.9-6.4-4.6-7.2C10.1 6.4 11.3 4.6 12 0z"/><path d="M12 24c-.7-4.6-1.9-6.4-4.6-7.2 2.7-.8 3.9-2.6 4.6-7.2.7 4.6 1.9 6.4 4.6 7.2-2.7.8-3.9 2.6-4.6 7.2z"/><path d="M0 12c4.6-.7 6.4-1.9 7.2-4.6.8 2.7 2.6 3.9 7.2 4.6-4.6.7-6.4 1.9-7.2 4.6C6.4 13.9 4.6 12.7 0 12z"/><path d="M24 12c-4.6.7-6.4 1.9-7.2 4.6-.8-2.7-2.6-3.9-7.2-4.6 4.6-.7 6.4-1.9 7.2-4.6.8 2.7 2.6 3.9 7.2 4.6z"/></svg>';

      var angle = (Math.PI * 2 * i) / 9 + Math.random() * 0.5;
      var dist = 46 + Math.random() * 54;

      s.style.left = cx + 'px';
      s.style.top = cy + 'px';
      s.style.setProperty('--dx', Math.cos(angle) * dist + 'px');
      s.style.setProperty('--dy', Math.sin(angle) * dist + 'px');
      s.style.setProperty('--rot', Math.round(Math.random() * 300 - 150) + 'deg');

      layer.appendChild(s);
      (function (node) {
        window.setTimeout(function () { node.remove(); }, 950);
      })(s);
    }
  }

  /* ------------------------------------------------------ scroll reveal */

  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    qsa('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    qsa('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Shopify theme editor hooks */
  document.addEventListener('shopify:section:load', function () {
    qsa('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
